import { Link } from "react-router-dom";

const ENTRIES = [
  {
    label: "电影",
    desc: "院线佳作",
    icon: "ri-film-line",
    to: "/category/movie",
    tone: "bg-primary-50 text-primary-600",
  },
  {
    label: "电视剧",
    desc: "热播剧集",
    icon: "ri-tv-2-line",
    to: "/category/tv",
    tone: "bg-accent-50 text-accent-600",
  },
  {
    label: "热门榜",
    desc: "人气精选",
    icon: "ri-fire-line",
    to: "/category/movie?sort=hot",
    tone: "bg-accent-50 text-accent-600",
  },
  {
    label: "最新更新",
    desc: "每日上新",
    icon: "ri-time-line",
    to: "/category/tv?sort=latest",
    tone: "bg-secondary-100 text-secondary-700",
  },
];

export default function QuickCategories() {
  return (
    <section className="mx-auto w-full px-4 md:px-6">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.label}
            to={entry.to}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 md:p-5"
          >
            <span
              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md ${entry.tone}`}
            >
              <i className={`${entry.icon} text-xl`}></i>
            </span>
            <span className="flex flex-col">
              <span className="font-heading text-base font-bold text-foreground-950 group-hover:text-accent-600">
                {entry.label}
              </span>
              <span className="mt-0.5 text-xs text-secondary-500">
                {entry.desc}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}